import React, { useEffect, useState } from 'react';
import getCampaignSummaryColumn from './SupplierCampaignSummaryGridConfig';
import getBtobCampaignSummaryColumn from './btobSupplierCampaignSummaryGridConfig';
import getOtherCampaignSummaryColumn from './otherSupplierCampaignSummaryGridConfig';
import SupplierCampaignModal from '../../Modals/SupplierCampaignModal';
import CommonTable from '../../Shared/Tables';
import APIService from '../../../Services/APIService';

const SupplierAnalytics = ({ campaignId, campaignType }) => {
  const [showModal, setShowModal] = useState(false)
  const [supplierDetails, setSupplierDetails] = useState([])
  const [bookingSubStatusDetails, setBookingSubStatusDetails] = useState({})
  const [supplierData, setSupplierData] = useState({})
  const [datas, setData] = useState([])
  const getSupplierCampaignDetails = async (id) => {
    let res = await APIService.get(`v0/ui/ops/campaign/supplier-count/?campaign_id=${id}`)
    if (res.status == 200) setSupplierData(res?.data);
  };

  const addMissingDatafield = (data) => {
    const dataFields = [
      'Not Booked',
      'Not Initiated',
      'Recce',
      'New Entity',
      'Decision Pending',
      'completed',
      'Confirmed Booking',
      'Rejected',
      'unknown',
      'Tentative Booking',
    ];
    dataFields.map((dataField) => {
      if (!data.hasOwnProperty(dataField)) {
        data[dataField] = 0;
      }
    });
    if (data.booking_sub_status) {
      setBookingSubStatusDetails(data.booking_sub_status)
    }
    setData([data])
  };

  useEffect(() => {
    if (campaignId)
      getSupplierCampaignDetails(campaignId)
    if (supplierData)
      addMissingDatafield(supplierData);
  }, [])

  const handleOpenModal = () => setShowModal(true)
  const handleCloseModal = () => setShowModal(false)

  const getSupplierDetails = async (id) => {
    let res = await APIService.get(`/v0/ui/ops/campaign/supplier-analytics/?campaign_id=${id}`);
    if (res.status == 200) {
      const listData = [];
      Object.keys(res.data).map((key) => {
        listData.push(res.data[key]);
      });
      setSupplierDetails(listData)
    }
  };

  const handleClick = async () => {
    await getSupplierDetails(campaignId);
    setShowModal(true)
  };

  const getTypeOfCampaign = () => {
    if (campaignType == 'b_to_c') {
      return getCampaignSummaryColumn();
    }
    if (campaignType == 'b_to_b') {
      return getBtobCampaignSummaryColumn();
    }
    if (campaignType == 'b_to_b_l_d') {
      return getOtherCampaignSummaryColumn();
    }
    if (campaignType == 'others') {
      return getOtherCampaignSummaryColumn();
    }
  };

  return (
    <div className="bootstrap-iso">
      {supplierData && (
        <div>
          <CommonTable id={'campaign_id'} columnsData={getTypeOfCampaign()} rowData={datas} />
          <button
            onClick={handleClick}
            className="btn btn-danger"
            style={{ marginTop: '10px', backgroundColor: '#e84478', borderColor: '#e84478' }}
          >
            View Details
          </button>
          <SupplierCampaignModal
            showModal={showModal}
            campaignId={supplierData.campaign_id}
            campaignName={supplierData.campaign_name}
            handleCloseModal={handleCloseModal}
            columns={getTypeOfCampaign()}
            data={supplierDetails}
          />
        </div>
      )}
    </div>
  );
}
export default SupplierAnalytics;
